import ErrorBoundary from "components/ErrorBoundary";
import ReactStrapTable from "components/reactStrapTable";
import React, { useState, useEffect } from "react";
import { CardBody, Container, Card, Input, Row, Col, Label, Button, Modal, ModalBody, ModalHeader, FormGroup, InputGroup, InputGroupText } from "reactstrap";
import commonColumns from "utils/columns";
import { cloneDeep } from "lodash";
import useAxios from 'hooks/useAxios';
import PatientList from "components/PatientList";
import useContextService from 'hooks/useContextService';
import { cellRendererCheck, dateFormate } from "utils/columns";
import { toast } from "react-toastify";
import Loader from "components/Loader";
import moment from 'moment';
import { Field, Formik } from 'formik';
import FormikInputField from "components/common/Fields/FormikInputField";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import Calendar from 'assets/icon/calendar-icon.svg';
import ReactInputMask from 'react-input-mask';
import DatePicker from "react-datepicker";
import plus from "assets/icon/AddWhite.svg";
import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";
import save from "assets/icon/save.svg";




let hasDatePopupOpen = false;
let initialValues = {};
const PatientNotFound = (props) => {


    const { coveredEntityID, tenantID, patientdata, patientTableData, fetchPatientmaplist, loading, togglepatient, refetch ,setLoading} = props;
    const { patientDOB,
        patientFirstName,
        patientLastName,
        rxNumber,
        claimID,
        dateofService } = patientdata;

    initialValues = {
        patientFirstName: patientFirstName || '',
        patientLastName: patientLastName || '',
        patientDOB: patientDOB || '',
    };



    const API = useAxios();


    const [patientmap, setPatientMap] = useState({});
    const [patientfirst, setpatientfirst] = useState('');
    const [patientlast, setpatientlast] = useState('');
    const [selected, setSelected] = useState(null);
    const [isOpenPatient, setisOpenPatient] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [startDateValue, setStartdateValue] = useState(null);
    const [datbirt, setDaebir] = useState(null);
    const [data, setData] = useState([]);
    const [focusedInput, setFocusedInput] = useState('');
    // const[loader,setLoader]=useState(false)
    //const [error, setError] = useState(false)

    useEffect(() => {
        setData(patientTableData)
    }, [patientTableData])


    useEffect(() => {
        var date = new Date(patientDOB)
        setStartdateValue(date);
    }, [])
    const formatDate = (patientDOB) => {
        const date = new Date(patientDOB);
        const options = {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZoneName: 'long'
        };
        return new Intl.DateTimeFormat('en-US', options).format(date).replace(',', '');
    }
    const renderCheckbox = (rowdata) => {

        return (
            <input
                onChange={() => onChange(rowdata)}
                type='checkbox'
                className='me-2 mt-0'
                checked={rowdata === selected}

            />);
    }
    const onChange = (i) => {
        setSelected((prev) => (i === prev ? null : i));
        setPatientMap(i);
    }

    let Maincol = [

        {

            text: 'Select',
            cellRenderer: (rowData) => renderCheckbox(rowData),
            width: 80,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },
        {
            dataField: 'patientFirstName',
            text: 'Patient First Name',
            cellRenderer: (rowData) => cellRendererCheck(rowData.patientFirstName),
            width: 80,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
            sort: false,
        },
        {
            dataField: 'patientLastName',
            text: 'Patient Last Name',
            cellRenderer: (rowData) => cellRendererCheck(rowData.patientLastName),
            width: 80,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },
        {
            dataField: 'patientDOB',
            text: 'Patient DOB',
            cellRenderer: (rowData) => dateFormate(rowData.patientDOB),
            width: 80,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },
    ]
    const handleAddpatient = () => {
        setisOpenPatient(!isOpenPatient);
    }
    const handlemap = async () => {
        setLoading(true)

        let payload = {};
        payload.PatientID = patientmap.patientID;
        payload.PatientFirstName = patientmap.patientFirstName;
        payload.PatientLastName = patientmap.patientLastName;
        payload.DateBirth = patientmap.patientDOB;
        payload.ClaimID = claimID;
        try {

            const { data } = await API.post(
                `/${tenantID}/Claim/UpdatePatientData`,
                payload
            );
            if (data) {
                        setLoading(false)

                toast.success(" Patient Mapped Successfully")
                togglepatient();
                refetch();
            }

        } catch (error) {
        setLoading(false)

        }
    };

    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handleStartDate = (startDate) => {
        if (startDate !== null) {
            const date = moment(startDate, 'MM/DD/YYYY', true);
            if (date.isValid()) {
                setStartdateValue(date.toDate());
            }
        }
        else {
            setStartdateValue(null);
        }
    };

    const handleStartDateRaw = (e) => {
        var val = e.target.value;
        if (val == '__/__/____' && startDateValue !== null) {
            setStartdateValue(null);
            //setError(false)
        }
        if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
            handleStartDate(e.target.value);
        }
    }

    const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };
    const handleDob = (dob) => {
        let stDate = dateFormate(dob);
        setStartDate(stDate);
        //handleAddDisabled(stDate);
    };
    const handleDob1 = (dob) => {

        let stDate = dateFormate(dob);
        setDaebir(stDate);
        //handleAddDisabled(stDate);
    };

    const handleFocus = (inputName) => {
        setFocusedInput(inputName);

    };

    const handleBlur = () => {

        setFocusedInput('');
    };

    const handleSubmit = async (e) => {

        let payload = {};
        //payload.PatientID = initialValues.patientID;
        payload.PatientFirstName = initialValues.patientFirstName;
        payload.PatientLastName = initialValues.patientLastName;
        payload.DateBirth = initialValues.patientDOB;
        try {
            const { data } = await API.post(
                `/${tenantID}/Claim/AddPatientData/${coveredEntityID}`,
                payload
            );
            if (data) {
                setisOpenPatient(!isOpenPatient);
                toast.success("Patient Added Successfully");
                fetchPatientmaplist(patientdata);
            } else {
                toast.error("Patient Already Exist")
                setisOpenPatient(!isOpenPatient);
            }

        } catch (error) {
        }

    }
    const handlePatientfname = (e) => {

        patientdata.patientFirstName = e.target.value;
    }
    const handlePatientLastname = (e) => {

        patientdata.patientLastName = e.target.value;
    }

    const getPatientfname = (e) => {

        setpatientfirst(e.target.value);
    }
    const getPatientLname = (e) => {
        setpatientlast(e.target.value);

    }
    const getPatientData = async (e) => {
        let patientData = {};
        patientData.PatientFirstName = patientfirst;
        patientData.PatientLastName = patientlast;
        patientData.DateBirth = startDateValue ? moment(startDateValue).format('MM/DD/YYYY') : null;
        //if (patientData.DateBirth != null) {
        try {
            const { data } = await API.post(
                `/${tenantID}/Claim/GetAllPatient`,
                patientData
            );
            if (data) {
                //setError(false);
                setData(data);
            }

        } catch (error) {
        }
        //}
        //  else {
        //     setError(true);
        // }
    }

    const onReset = () => {
        setData([]);
        setpatientlast('');
        setpatientfirst('');
        setSelected(null)
        //setStartdateValue(null);
        //setError(false);
    }
    return (<div>

        <Card className="mb-3 shadow-top">
            <CardBody>
                <ErrorBoundary>
                    <Row className='justify-content-between align-items-center'>
                        <Col md='3' className='pe-3'>
                            <p className='f-14 mb-0'>
                                Patient First Name :
                                <b className='d-block font-weight-500'> {patientFirstName}</b>
                            </p>
                        </Col>
                        <Col md='3' className='pe-3'>
                            <p className='f-14 mb-0'>
                                Patient Last Name :
                                <b className='d-block font-weight-500'>
                                    {patientLastName}
                                </b>
                            </p>

                        </Col>
                        <Col md='3' className='pe-3'>
                            <p className='f-14 mb-0'>
                                Patient DOB :
                                <b className='d-block font-weight-500'>
                                    {moment(patientDOB).format('MM/DD/YYYY')}

                                </b>
                            </p>

                        </Col>
                        <Col md='3' className='pe-3'>
                            <p className='f-14 mb-0'>
                                ClaimID  :
                                <b className="d-block font-weight-500">
                                    {claimID}
                                </b>
                            </p>

                        </Col>
                    </Row>

                    <Row className="mt-3">
                        <Col md='6'>
                            <Row>
                                <Col md='6' className='pe-3'>
                                    <p className='f-14 mb-0'>
                                        RX Number :
                                        <b className="d-block font-weight-500">
                                            {rxNumber}
                                        </b>
                                    </p>

                                </Col>
                                <Col md='6' className='pe-3'>
                                    <p className='f-14 mb-0'>
                                        Date Of Service :
                                        <b className="d-block font-weight-500">
                                            {moment(dateofService).format('MM/DD/YYYY')}

                                        </b>
                                    </p>

                                </Col>
                            </Row>
                        </Col>


                        <Col md='6' className='' style={{ textAlign: "right" }}>

                            <Button onClick={handleAddpatient}
                                color="primary"
                                type="submit"
                                className="search">
                                <span className="right_5">
                                    <img src={plus} alt="" />
                                </span>{" "} Add
                            </Button>

                        </Col>
                    </Row>

                </ErrorBoundary>
            </CardBody>

        </Card>


        <Card className="shadow-top">
            <CardBody>
                <Formik initialValues={''}
                    onSubmit={handleSubmit}
                    // validationSchema={validationSchema}
                    enableReinitialize={true}
                    children={(props) => {
                        const { isSubmitting, handleSubmit, resetForm, setFieldValue } = props;
                        return (<div>
                            <Row>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label>Patient First Name</Label>
                                        <Input type="text" name="patientfirst" placeholder="Enter Patient First Name" value={patientfirst} onChange={(e) => setpatientfirst(e.target.value)} />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label>Patient Last Name</Label>
                                        <Input type="text" name="patientlast" placeholder="Enter Patient Last Name" value={patientlast} onChange={(e) => setpatientlast(e.target.value)} />
                                    </FormGroup>

                                </Col>
                                {/*<Col md={3}>
                                        <FormGroup>
                                            <Label>Patient DOB</Label>
                                            <InputGroup >
                                                <Field
                                                    type='text'
                                                    id='datbirt'
                                                    name='datbirt'
                                                    autoComplete='off'

                                                    placeholder='Select a date'
                                                    value={datbirt}
                                                    component={FormikDatePicker}
                                                    onChange={handleDob1}
                                                    onKeyDown={(e) => {
                                                        e.preventDefault();
                                                    }}

                                                />
                                                <InputGroupText
                                                    onClick={() => handleDateClick('datbirt')}
                                                >
                                                    <img src={Calendar} alt='' />
                                                </InputGroupText>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>*/}

                                <Col md={3} className='required-date'>
                                    <FormGroup>
                                        <Label></Label>
                                        <Label
                                            htmlFor="StartDate" for='reportname'
                                            className={focusedInput === 'StartDate' ? 'label-focus' : ''}
                                        >Date of Birth</Label>
                                        <InputGroup onMouseLeave={handleMouseLeave}>
                                            {/* <Field
                                                            setcss="required"
                                                            type='text'
                                                            id='StartDate'
                                                            name='StartDate'
                                                            autoComplete='off'
                                                            placeholder='Select a date'
                                                            value={startDateValue}
                                                            component={FormikDatePicker}
                                                            onChange={handleStartDate}
                                                            onFocus={() => handleFocus('StartDate')}
                                                            onBlur={handleBlur}
                                                        /> */}
                                            <DatePicker

                                                id='startDate'
                                                name='startDate'
                                                selected={startDateValue}

                                                onChange={handleStartDate}
                                                onFocus={() => handleFocus('StartDate')}
                                                // onBlur={handleBlur}
                                                isClearable={false}
                                                onChangeRaw={handleStartDateRaw}
                                                dateFormat="MM/dd/yyyy"
                                                placeholderText='MM/dd/yyyy'
                                                autoComplete='off'
                                                disabled={true}
                                                customInput={
                                                    <ReactInputMask mask="99/99/9999"
                                                        value={startDateValue}
                                                    // maskChar=''
                                                    />

                                                }
                                            />
                                            <InputGroupText
                                                disabled={true}
                                                onClick={() => handleDateClick('StartDate')}
                                            >
                                                <img src={Calendar} alt='' />
                                            </InputGroupText>
                                            {/* {error && <div className="text-danger f-12" style={{ position: "relative", left: "190px" }}>
                                                    Date of Birth is a required field</div>} */}
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row className="d-flex mb-3" style={{ justifyContent: "flex-end" }}>
                                <Col md="auto" className="">

                                    {/* <Col md={9} className='pt-4 mt-1' style={{ textAlign: "right" }}> */}
                                    <Button color="primary" disabled={patientfirst == '' && patientlast == ''} onClick={getPatientData}
                                        className="search">
                                        <span className="right_5">
                                            <img src={search} alt="" />
                                        </span>{" "} Search</Button>
                                    <Button color="primary" className="reset ms-2" onClick={onReset}><span className="right_5">
                                        <img src={reseticon} alt="" />
                                    </span>{" "} Reset</Button>
                                </Col>
                            </Row>
                        </div>)
                    }}>

                </Formik>

                <ErrorBoundary>
                    <div className='table-card scroll-table position-relative border-0 rounded pt-0'
                        fixed-height={data.length > 0 ? 'fixed-height' : 'default'}>
                        {loading && <Loader opacity={0.01} color='black' />}
                        <ReactStrapTable id="claims-patient-details" columns={Maincol} data={data} />
                        <Button style={{ float: "right", "margin-top": "20px" }} onClick={handlemap} disabled={(!selected || loading) || data.length==0}
                            color="primary"

                            className="search">
                            <span className="right_5">
                                <img src={save} alt="" />
                            </span>{" "}  Map
                        </Button>
                    </div>

                </ErrorBoundary>
            </CardBody>
        </Card>

        <Modal
            isOpen={isOpenPatient}
            toggle={handleAddpatient}
            size='xl'
            className='xl'
        >
            <ModalHeader toggle={handleAddpatient}>
                <h4 className='font-weight-600' style={{ color: "#702C62", }}>Add Patient</h4>
            </ModalHeader>
            <ModalBody>

                <Formik initialValues={initialValues}
                    onSubmit={handleSubmit}
                    // validationSchema={validationSchema}
                    enableReinitialize={true}
                    children={(props) => {
                        const { isSubmitting, handleSubmit, resetForm, setFieldValue } = props;
                        return (
                            <div>
                                <Row>
                                    <Col md={3}>
                                        <FormGroup>
                                            <Field
                                                key='patientFirstName'
                                                id='patientFirstName'
                                                name='patientFirstName'
                                                type='text'

                                                component={FormikInputField}
                                                onKeyUp={handlePatientfname}
                                                label='Patient First Name'
                                                autoComplete='off'
                                                disabled={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={3}>
                                        <FormGroup>
                                            <Field
                                                key='patientLastName'
                                                id='patientLastName'
                                                name='patientLastName'
                                                type='text'
                                                component={FormikInputField}
                                                onKeyUp={handlePatientLastname}
                                                label='Patient Last Name'
                                                autoComplete='off'
                                                disabled={true}
                                            />
                                        </FormGroup>

                                    </Col>
                                    <Col md={3}>

                                        <FormGroup>
                                            <Label>Patient DOB</Label>
                                            <InputGroup >
                                                <Field
                                                    type='text'
                                                    id='PatientDb'
                                                    name='PatientDb'
                                                    autoComplete='off'

                                                    placeholder='Select a date'
                                                    value={startDate ? startDate : moment(patientDOB).format('MM/DD/YYYY')}
                                                    component={FormikDatePicker}
                                                    onChange={handleDob}
                                                    onKeyDown={(e) => {
                                                        e.preventDefault();
                                                    }}
                                                    disabled={true}
                                                />
                                                <InputGroupText
                                                    onClick={() => handleDateClick('PatientDb')}
                                                >
                                                    <img src={Calendar} alt='' />
                                                </InputGroupText>
                                            </InputGroup>
                                        </FormGroup>

                                    </Col>
                                </Row>

                                <Row md="auto" style={{ justifyContent: "flex-end" }}>
                                    <Col sm={2} className="d-flex justify-content-end">
                                        <Label>&nbsp;&nbsp;&nbsp;</Label>
                                        <Button style={{ float: "right" }} onClick={handleSubmit}
                                            color="primary"
                                            className="search">
                                            <span className="right_5">
                                                <img src={save} alt="" />
                                            </span>{" "} Save
                                        </Button>
                                    </Col>
                                </Row>

                            </div>

                        );
                    }}>

                </Formik>

            </ModalBody>
        </Modal>

    </div>)
};
export default PatientNotFound;
